export default defineAppConfig({
  title: 'Eurol'
})
